// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VtmfFilingActionResponse
 */
export interface VtmfFilingActionResponse {
    /**
     * 
     * @type {string}
     * @memberof VtmfFilingActionResponse
     */
    filing_id?: string;
    /**
     * 
     * @type {string}
     * @memberof VtmfFilingActionResponse
     */
    status?: string;
}

/**
 * Check if a given object implements the VtmfFilingActionResponse interface.
 */
export function instanceOfVtmfFilingActionResponse(value: object): value is VtmfFilingActionResponse {
    return true;
}

export function VtmfFilingActionResponseFromJSON(json: any): VtmfFilingActionResponse {
    return VtmfFilingActionResponseFromJSONTyped(json, false);
}

export function VtmfFilingActionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): VtmfFilingActionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'filing_id': json['filing_id'] == null ? undefined : json['filing_id'],
        'status': json['status'] == null ? undefined : json['status'],
    };
}

export function VtmfFilingActionResponseToJSON(json: any): VtmfFilingActionResponse {
    return VtmfFilingActionResponseToJSONTyped(json, false);
}

export function VtmfFilingActionResponseToJSONTyped(value?: VtmfFilingActionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'filing_id': value['filing_id'],
        'status': value['status'],
    };
}
